
export function toBlogDetail(id, is_with_sidebar)
{
    let url = "/blog-details"
    if(is_with_sidebar === 1) {
        url = "/blog-details-sidebar"
    }
    return `${url}/${id}`
}